<!-- Tab Navigation -->
<div class="tab-nav">
  <button class="tab-button" [class.active]="selectedTab() === 'tips'" (click)="selectTab('tips')">
    <span class="tab-label">Tips</span>
    <div class="tab-underline"></div>
  </button>

  <button
    class="tab-button"
    [class.active]="selectedTab() === 'outline'"
    [class.disabled-tab-button]="!cbProject?.challengeBuilder?.initialGoal"
    [matTooltip]="!cbProject?.challengeBuilder?.initialGoal ? 'Enter an initial goal' : ''"
    (click)="cbProject?.challengeBuilder?.initialGoal && selectTab('outline')"
  >
    <span class="tab-label">Outline</span>
    <div class="tab-underline"></div>
  </button>
</div>

<!-- Tab Content -->
<div class="tab-content oph-scroll-bar">
  @if (selectedTab() === 'tips') {
    <div class="tips-container">
      <h2 class="tips-header">{{ stepMap[currentStep].tipHeaderText }}</h2>

      @for (tip of stepMap[currentStep].tips; track $index) {
        @if (tip.type === 'check') {
          <div class="tip-check-item">
            <div class="tip-check-header">
              <oph-icon name="check-white-bg" [size]="24"></oph-icon>

              <h3 class="tip-check-title">{{ tip.title }}</h3>
            </div>
            <p class="tip-check-description">{{ tip.description }}</p>
          </div>
        } @else if (tip.type === 'bullet') {
          <div class="tip-bullet-item">
            <h3 class="tip-bullet-title">{{ tip.title }}</h3>
            <ul class="tip-bullet-list">
              @for (bulletPoint of tip.bulletPoints; track $index) {
                <li class="tip-bullet-point">{{ bulletPoint }}</li>
              }
            </ul>
          </div>
        } @else if (tip.type === 'boolean') {
          <div class="tip-check-item">
            <div class="tip-check-header">
              <oph-icon name="check-white-bg" [size]="24"></oph-icon>

              <h3 class="tip-check-title">{{ tip.title }}</h3>
            </div>
            <p class="tip-check-description">{{ tip.description }}</p>

            @for (example of tip.examples; track $index) {
              <div class="metric-example">
                <span class="metric-example-label">{{ example.label }}</span>
                <div class="metric-boolean-toggle">
                  <span class="boolean-option" [class.active]="example.booleanType === 'no-active'">yes</span>
                  <div class="boolean-divider"></div>
                  <span class="boolean-option highlighted" [class.active]="example.booleanType === 'yes-active'"
                    >no</span
                  >
                </div>
              </div>
            }
          </div>
        } @else if (tip.type === 'numeric') {
          <div class="tip-check-item">
            <div class="tip-check-header">
              <oph-icon name="check-white-bg" [size]="24"></oph-icon>

              <h3 class="tip-check-title">{{ tip.title }}</h3>
            </div>
            <p class="tip-check-description">{{ tip.description }}</p>

            @for (example of tip.examples; track $index) {
              <div class="metric-example">
                <span class="metric-example-label">{{ example.label }}</span>
                <div class="metric-numeric-input">
                  <div class="numeric-value">{{ example.value }}</div>
                  <span class="numeric-unit">{{ example.unit }}</span>
                </div>
              </div>
            }
          </div>
        } @else if (tip.type === 'percentage') {
          <div class="tip-check-item">
            <div class="tip-check-header">
              <oph-icon name="check-white-bg" [size]="24"></oph-icon>

              <h3 class="tip-check-title">{{ tip.title }}</h3>
            </div>
            <p class="tip-check-description">{{ tip.description }}</p>

            @for (example of tip.examples; track $index) {
              <div class="metric-example">
                <span class="metric-example-label">{{ example.label }}</span>
                <div class="metric-percentage-container">
                  <div class="percentage-slider">
                    <div class="slider-track">
                      <div class="slider-fill" [style.width.%]="example.value"></div>
                    </div>
                    <div class="slider-thumb" [style.left.%]="example.value"></div>
                  </div>
                  <div class="metric-numeric-input">
                    <div class="numeric-value">{{ example.value }}</div>
                    <span class="numeric-unit">%</span>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else if (tip.type === 'duration') {
          <div class="tip-check-item">
            <div class="tip-check-header">
              <oph-icon name="check-white-bg" [size]="24"></oph-icon>

              <h3 class="tip-check-title">{{ tip.title }}</h3>
            </div>
            <p class="tip-check-description">{{ tip.description }}</p>

            @for (example of tip.examples; track $index) {
              <div class="metric-example">
                <span class="metric-example-label">{{ example.label }}</span>
                <div class="metric-duration-input">
                  @if (example.hours) {
                    <div class="duration-field">{{ example.hours }}</div>
                  }
                  @if (example.minutes) {
                    <div class="duration-field">{{ example.minutes }}</div>
                  }
                  @if (example.seconds) {
                    <div class="duration-field">{{ example.seconds }}</div>
                  }
                </div>
              </div>
            }
          </div>
        } @else if (tip.type === 'text') {
          <p class="tip-text">{{ tip.description }}</p>
        }
      }
    </div>
  } @else if (selectedTab() === 'outline') {
    <cb-outline [cbProject]="cbProject"></cb-outline>
  }
</div>
